<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()

    export let options: { label: string; value: any }[]
    let className = ''
    export { className as class }
    export let value = null
    export let label = null
    export let small = false
    export let multi = false
    export let vertical = false

    function optionSelected(selected) {
        if (multi) {
            // se é multi opções, adiciona/remove do array
            const findIndex = value.indexOf(selected)
            if (findIndex >= 0) {
                value.splice(findIndex, 1)
            } else {
                value.push(selected)
            }
        } else {
            value = options.find((el) => el.value === selected)?.value
        }
        options = options
        dispatch('change', value)
    }

    function checkSelected(current) {
        if (value === undefined || value === null) return false
        if (!multi) {
            if (JSON.stringify(current) === JSON.stringify(value)) {
                return true
            } else {
                return false
            }
        }
        return value.indexOf(current) >= 0
    }

    onMount(() => {
        if (multi && !value) {
            value = new Array()
        }
    })

    $: {
        if (!!value || !value) {
            options = options
        }
    }
</script>

<div class="select-all {className}">
    {#if label}
        <label for="" class="input-group-text" class:small>{label}</label>
    {/if}

    <div class:btn-group={!vertical} class:btn-group-vertical={vertical}>
        {#each options as option, i}
            <button
                on:click={() => optionSelected(option.value)}
                class="btn btn-secondary btn-sm"
                class:active={checkSelected(option.value)}
                class:inactive={!checkSelected(option.value)}>{option.label}</button
            >
        {/each}
    </div>
</div>

<style>
    .input-group-text {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    .select-all {
        opacity: 0.85;
        width: 100%;
        display: flex;
    }
    .select-all .btn-group {
        flex-grow: 1;
    }
    .select-all button {
        flex-grow: 1;
    }
    .active {
        opacity: 1;
        background-color: #328866;
    }
    .active:focus {
        background-color: #328866;
    }

    .small {
        padding-top: 0px;
        padding-bottom: 0px;
    }

    @media (max-width: 900px) {
        .select-all {
            flex-direction: column;
        }
    }
</style>
